<template>
    <div class="components-pager">
        <div class="btn prev">
            <img class="icon" src="/images/pager/icon-page-prev.png" @click="prevPage" />
        </div>

        <div class="btn page">

            <!-- <div class="item hover easy" v-if="page_num_list.length>0 && page_num_list[0]!=1">首页</div> -->
             <div class="item easy" v-if="page_num_list.length>0 && page_num_list[0]!=1" disabled>···</div>

            <div class="list" >
                <div class="item hover is_bg" 
                v-for="(item, index) in page_num_list" :key="index"
                :class="{
                    'active':page_current==item
                }"
                @click="jumpPage(item)"
                >{{item}}</div>
            </div>

            <div class="item easy" v-if="page_num_list.length>0 && page_num_list[page_num_list.length-1]!=page_total" disabled>···</div>

            <!-- <div class="item hover easy" >末页</div> -->
        </div>

        <div class="btn next">
            <img class="icon" src="/images/pager/icon-page-next.png" @click="nexPage" />
        </div>

        <div class="btn jump">
            <a-input-number class="input" v-model="page_jump" :max="page_total" :min="1" ></a-input-number>
            <span @click="goJump">跳转到该页</span>
        </div>

        <div class="btn total">
            <span>共{{ page_total }}页</span>
        </div>

    </div>
</template>

<script>
export default {
    props:{
        total:{
            type    : Number,
            default : 0
        },
        limit:{
            type    : Number,
            default : 0
        }
    },
    data(){
        return {
            // 页码列表
            "page_num_list" : [],

            // 当前页
            "page_current"  : 2,

            // 跳转页面
            "page_jump" : "",

            // 每页多少条
            "page_limit" : 10,

            // 总页数
            "page_total" : 0,

            // 数据总数
            "data_total" : 191,

            "show_limit"    : 7,

        };
    },
    watch:{
        total(value){
            this.data_total = value;
            this.initRender();
        },
        limit(value){
            this.page_limit = value;
            this.initRender();
        }
    },
    created(){
        this.page_limit = this.limit;
        this.data_total = this.total;

        this.initRender();
    },
    methods:{
        // 初始化数据
        initRender(){
            this.page_current = 1;
            this.buildPage();
            this.buildNumList();
        },
        goJump(){
            this.jumpPage(this.page_jump);
        },
        // 跳转
        jumpPage(page){
            if(page>=1 && page <=this.page_total){
                if(page!=this.page_current){
                    this.page_current = parseInt(page);
                    this.buildNumList();
                    this.$emit("currentPage",this.page_current);
                }
            }
        },

        // 上一页
        prevPage(){
            if(this.page_current>1){
                this.page_current -= 1;

                this.buildNumList();
            }
        },
        // 下一页
        nexPage(){
            if(this.page_current<this.page_total){
                this.page_current += 1;

                // var page_num_list = this.page_num_list;
                // if(page_num_list.length>0 && page_num_list[page_num_list.length-1]<(this.page_current+2)){
                //     this.buildNumList();
                // }
                this.buildNumList();
            }
        },

        // 构建页码表
        buildNumList:function(){
            var page_num_list = [];
            var page_current = this.page_current;
            var page_total = this.page_total;

            var show_limit = this.show_limit;

            var show_limit = this.show_limit-2;

            var group_num = Math.ceil(page_total/show_limit);
            for(var i=0;i<group_num;i++){
                if( i*show_limit< page_current && (i+1)*show_limit>=page_current ){
                    var l = i*show_limit+1;
                    var m = (i+1)*show_limit;
                    if( m > page_total){
                        m = page_total;
                    }
                    if(i>0){
                        page_num_list.push(l-1);
                    }
                    while(l <= m){
                        page_num_list.push(l);
                        l++;
                    }
                    if(i!=group_num-1){
                        page_num_list.push(page_num_list[page_num_list.length-1]+1);
                    }
                }
            }
            // // 如果总页数 没有这么多
            // if( page_total < show_limit ){
            //     for(var i=page_current;i<show_limit;i++){
            //         page_num_list.push(i);
            //     }
            // }else{
            //     var page_end = page_current+show_limit;

            //     if( page_end > page_total ){
            //         page_end = page_total;
            //     }
            //     for(var i=page_current;i<page_end;i++){
            //         page_num_list.push(i);
            //     }
            // }

            this.page_num_list = page_num_list;
        },
        buildPage:function(){
            this.page_total = Math.ceil(this.data_total/this.page_limit);
        }
    }
}
</script>

<style lang="less">
.ant-input-number-input{
    width: 50px!important;
}
</style>
<style lang="less" scoped>
.components-pager{
    display: inline-block;
    > .btn{
        display: inline-block;
        vertical-align: middle;
        margin-right: 15px;
        &:last-child{
            margin-right: 0px;
        }
        &.prev, &.next{
            cursor: pointer;
            height:15px;
            margin-top:-7px;
            .icon{
                height: 100%;
            }
        }
        &.page{
            padding-top: 7px;
            .list{
                display: inline-block;vertical-align: middle;
            }

            .item{
                
                display: inline-block;
                vertical-align: middle;
                font-size:13px;
                width:35px;
                text-align: center;
                padding: 7px 0px 10px 0px;
                margin:0px 5px;
                color: #6A6767;
                font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
                font-weight: 700;
                &.hover{
                    cursor: pointer;
                }
                &.easy{
                    font-size:12px;
                    font-weight: 400;
                }
                &.is_bg{
                    background-image: url('/images/pager/icon-page-default.png');
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
                &.active, &:hover{
                    &.is_bg{
                        background-image: url('/images/pager/icon-page-select.png');
                    }
                }

            }
        }

        &.jump{
            padding-top:4px;
            margin-left: 10px;
            .input{
                width: auto;
            }
            /deep/ .el-input__inner{
                width:40px;
                padding: 6px 5px;
                background-color: #f5f5f5;
                border: 1px solid #ddd;
                border-radius: 3px;
            }
            span{
                font-size: 12px;margin-left: 8px;
                font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
                font-weight: 400;
                color: #333333;
            }
        }
        &.total{
            padding-top:4px;
            font-size: 12px;margin-left: 10px;
            font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
            font-weight: 400;
            color: #333333;
        }
    }
}
</style>